import type { PersonCheckInApi } from "../../api/PersonCheckInApi";
import type { CardFetchOptions } from "../../generated/dto/CardFetchOptions";
import type { CardStaff } from "../../generated/dto/CardStaff";
import type { DeletePersonCheckInStaff } from "../../generated/dto/DeletePersonCheckInStaff";
import type { PersonCheckIn } from "../../generated/dto/PersonCheckIn";
import type { PersonCheckInCreatePersonCheckInWithLookupRequest } from "../../generated/dto/PersonCheckInCreatePersonCheckInWithLookupRequest";
import type { PersonCheckInFetchOptions } from "../../generated/dto/PersonCheckInFetchOptions";
import type { PersonCheckInSearchParams } from "../../generated/dto/PersonCheckInSearchParams";
import type { PersonCheckInStaff } from "../../generated/dto/PersonCheckInStaff";
import type { PersonCheckInStaffSearchResult } from "../../generated/dto/PersonCheckInStaffSearchResult";
import type { PersonFetchOptions } from "../../generated/dto/PersonFetchOptions";
import type { PersonStaff } from "../../generated/dto/PersonStaff";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class PersonCheckInFrontendService {
  constructor(private readonly api: PersonCheckInApi) {}
  async getPersonCheckInStaff(id: number, options?: PersonCheckInFetchOptions): Promise<PersonCheckInStaff> {
    return this.api.getPersonCheckInStaff(id, options)
  }
  async deletePersonCheckInStaff(source: DeletePersonCheckInStaff): Promise<void> {
    return this.api.deletePersonCheckInStaff(source)
  }
  async searchPersonCheckInStaff(params: PersonCheckInSearchParams, page: number, perPage: number): Promise<PaginationResult<PersonCheckInStaffSearchResult>> {
    return this.api.searchPersonCheckInStaff(params, page, perPage)
  }
  async searchPersonCheckInStaffFull(params: PersonCheckInSearchParams, page: number, perPage: number, options?: PersonCheckInFetchOptions): Promise<PaginationResult<PersonCheckInStaff>> {
    return this.api.searchPersonCheckInStaffFull(params, page, perPage, options)
  }
  async getPersonCheckInStaffPersonId(id: number, options?: PersonFetchOptions): Promise<PersonStaff> {
    return this.api.getPersonCheckInStaffPersonId(id, options)
  }
  async getPersonCheckInStaffCardId(id: number, options?: CardFetchOptions): Promise<CardStaff | null> {
    return this.api.getPersonCheckInStaffCardId(id, options)
  }
  async createPersonCheckInWithLookupStaff(request: PersonCheckInCreatePersonCheckInWithLookupRequest): Promise<PersonCheckIn> {
    return this.api.createPersonCheckInWithLookupStaff(request)
  }
}
